let widgetModulePromise;
export const loadWidgetModule = () => {
    if (!widgetModulePromise) {
        widgetModulePromise = import(/* webpackChunkName: "smm-auth-widget-ui" */ "./ui/mount").catch((error) => {
            widgetModulePromise = undefined;
            throw error;
        });
    }
    return widgetModulePromise;
};
//# sourceMappingURL=widget-module.js.map